<div class="flex justify-content-center flex-wrap">
    <div class="flex align-items-center justify-content-center w-full font-bold border-round m-2 text-3xl title-case">
        Edit Contract
    </div>
</div>

<div class="mb-2">
    <p-card>
        <form [formGroup]="contractDetailsForm" class="centered">
            <div class="formgrid grid">
                <div class="field col-12 md:col-4">
                    <label for="partnerId" class="required-field">PAC : </label>
                    <div>
                        <input id="partnerId" type="text" pInputText formControlName="pac" class="w-8">
                        <div *ngIf="!contractDetailsForm.controls['pac'].valid && contractDetailsForm.controls['pac'].dirty"
                            class="error-msg">
                            <span *ngIf="contractDetailsForm.controls['pac']?.hasError('required')">
                                PAC is required</span>
                            <span *ngIf="contractDetailsForm.controls['pac']?.hasError('pattern')">
                                PAC should be alphanumeric</span>
                            <span *ngIf="contractDetailsForm.controls['pac']?.hasError('maxlength') && !contractDetailsForm.controls['pac']?.hasError('pattern')">
                                    Maximum length of the PAC should be 13
                            </span>
                            <span *ngIf="contractDetailsForm.controls['pac']?.hasError('minlength') && !contractDetailsForm.controls['pac']?.hasError('pattern')">
                                    Minimum length of the PAC should be 12
                            </span>
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-4">
                    <label for="partnerId" class="required-field">Contract ID : </label>
                    <div>
                        <input id="partnerId" type="text" pInputText formControlName="contractId" class="w-8">
                        <div *ngIf="!contractDetailsForm.controls['contractId'].valid && contractDetailsForm.controls['contractId'].dirty"
                            class="error-msg">
                            <span *ngIf="contractDetailsForm.controls['contractId']?.hasError('required')"
                                class="error-msg">
                                Contract Id is required</span>
                            <span *ngIf="contractDetailsForm.controls['contractId']?.hasError('pattern')">
                                Contract Id should be numeric</span>
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-4">
                    <label for="partnerId" class="required-field">Receiver Manufacturer : </label>
                    <div>
                        <p-dropdown [filter]="true" 
                                    name="receiverManufacturer" 
                                    [options]="recieverManufacturerResponse"
                                    optionLabel="name" 
                                    placeholder="Select Manufacturer" 
                                    [showClear]="true"
                                    formControlName="receiverManufacturer"
                                    styleClass="w-8"
                                    >
                        </p-dropdown>
                        <div *ngIf="!contractDetailsForm.controls['receiverManufacturer'].valid && contractDetailsForm.controls['receiverManufacturer'].dirty"
                            class="error-msg">
                            <span *ngIf="contractDetailsForm.controls['receiverManufacturer']?.hasError('required')"
                                class="error-msg">
                                Receiver Manufacturer is required</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex justify-content-center flex-wrap">
                <button pButton type="button" label="Fetch Contract Details" class="btnClass"
                    (click)="getContractDetails()" [disabled]="contractDetailsForm.invalid"></button>
            </div>
        </form>
    </p-card>
</div>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle">
</p-confirmDialog>

<p-card *ngIf="isDataAvailable">
    <form [formGroup]="editContractForm" class="centered">
        <div class="formgrid grid">
            <div class="field col-12 md:col-4">
                <label for="productCode" class="required-field">Product Code : </label>
                <div>
                    <p-inputMask formControlName="productCode"
                                 mask="9999-99-9" 
                                 styleClass="w-8" 
                    ></p-inputMask>
                    <div *ngIf="!editContractForm.controls['productCode'].valid && editContractForm.controls['productCode'].dirty"
                        class="error-msg">
                        <span *ngIf="editContractForm.controls['productCode']?.hasError('required')"
                            class="error-msg">
                            Product Code is required</span>
                        <span *ngIf="editContractForm.controls['productCode']?.hasError('pattern')"
                            class="error-msg">
                            Product Code should be in the format 9999-99-9</span>
                    </div>
                </div>
            </div>

            <div class="field col-12 md:col-4" *ngIf="enableFields">
                <label for="serviceLevel" class="required-field">Service Offering : </label>
                <div>
                    <p-dropdown [filter]="true" 
                    [options]="serviceLevelResponse" 
                    [virtualScroll]="true"
                    formControlName="serviceLevel" 
                    styleClass="w-8" 
                    optionLabel="name"
                    optionValue="name"
                    placeholder="select service offering"
                    (onChange)="onChangeServiceLevel($event)">
                    </p-dropdown>
                </div>
            </div>

            <div class="field col-12 md:col-4" *ngIf="enableFields"> 
                <label for="geogatingMode">Geogating Mode : </label>
                <div>
                    <p-dropdown [filter]="true" 
                                [options]="geoGatingMode"
                                [virtualScroll]="true"
                                formControlName="geogatingMode" 
                                placeholder="select geogating mode"
                                optionLabel="name"
                                optionValue="value"
                                styleClass="w-8" 
                                (onChange)="onChangeGeogatingMode($event)"
                    ></p-dropdown>
                </div>
            </div>

            <div class="field col-12 md:col-4">
                <label for="partnerId">Partner ID : </label>
                <div>
                    <input id="partnerId" type="text" pInputText formControlName="partnerId" class="w-8">
                </div>
            </div>

            <div class="field col-12 md:col-4">
                <label for="partnerName" class="">Partner Name : </label>
                <div>
                    <input id="partnerName" type="text" pInputText formControlName="partnerName" class="w-8">
                </div>
            </div>

            <div class="field col-12 md:col-4">
                <label for="coverageLevel">Coverage Level : </label>
                <div>
                    <input id="coverageLevel" type="text" pInputText formControlName="coverageLevel" class="w-8">
                </div>
            </div>


            <div class="field col-12 md:col-4">
                <label for="startDate" class="">Start Date(UTC) : </label>
                <div>
                    <input id="startDate" type="text" pInputText class="w-8"
                        value="{{contractsList?.activationStartDate | date: 'MMM dd yyyy HH:mm'}}" disabled>
                </div>
            </div>

            <div class="field col-12 md:col-4">
                <label for="endDate">End Date(UTC) : </label>
                <div>
                    <input id="endDate" type="text" pInputText class="w-8"
                        value="{{contractsList?.contractEndDate | date: 'MMM dd yyyy HH:mm'}}" disabled>
                </div>
            </div>


            <div class="field col-12 md:col-4" *ngIf="contractsList?.serviceCoverage !== 'Global'">
                <label for="country"  class="required-field" >Country : </label>
                <div>
                    <p-dropdown [filter]="true" 
                                placeholder="select country" 
                                [options]="countryResponse"
                                optionValue="name" 
                                [virtualScroll]="true" 
                                formControlName="countryName" 
                                styleClass="w-8" 
                                optionLabel="name" 
                                (onChange)="onChangeCountry($event)"
                                [showClear]="true">
                    </p-dropdown>
                </div>
            </div>
            <div class="field col-12 md:col-4" *ngIf="contractsList?.serviceCoverage !== 'Global'">
                <label for="longitude">Longitude : </label>
                <div>
                    <input id="longitude" type="number" pInputText formControlName="longitude" class="w-8" >
                    <div *ngIf="!editContractForm.controls['longitude'].valid && editContractForm.controls['longitude'].dirty"
                    class="error-msg">
                    <span *ngIf="editContractForm.controls['longitude']?.hasError('min')">
                        Longitude should have -180 as minimum</span>
                    <span *ngIf="editContractForm.controls['longitude']?.hasError('max')">
                        Longitude should have 180 as maximum</span>
                    <span *ngIf="editContractForm.controls['longitude']?.hasError('pattern')">
                        Longitude should be in the range -180 to 180 and should contain only 7 decimal point</span>
                </div>
                </div>
            </div>

        </div>
        <div class="flex flex-wrap">
            <div class="flex align-items-center justify-content-center m-2"><i class="pi pi-exclamation-triangle" style="color: orange;"></i></div>
            <div class="flex align-items-center justify-content-center m-1 menu-item-text">To change geogating, service level or delivery method, the product code must be updated.
                
                </div>
        </div>
        <div class="flex justify-content-center flex-wrap">
            <div class="flex align-items-center justify-content-center w-11rem h-4rem font-bold border-round m-4">
                <button pButton type="button" label="Update Contract" class="btnClass" (click)="saveContract()" [disabled]="checkFieldValues() || editContractForm.invalid"></button>
            </div>
            <div class="flex align-items-center justify-content-center w-5rem h-4rem font-bold border-round m-4">
                <button pButton type="button" label="Cancel" class="btnClass" (click)="onCancel()" style="min-width: 100px"></button>
            </div>
        </div>

    </form>
</p-card>

<div *ngIf="noRecordsFound" class="flex align-items-center justify-content-center">
        No Data Available
</div>

<p-toast position="top-center" life="4000"></p-toast>
